import { NgModule } from '@angular/core';
//import { CommonModule } from '@angular/common';

import { DropboxImagenDisplayPipe } from './dropbox-imagen-display.pipe';
import { DomsanitizerPipe } from './domsanitizer.pipe';




@NgModule({
	declarations: [
		DropboxImagenDisplayPipe,
		DomsanitizerPipe
	],
	exports: [
		DropboxImagenDisplayPipe,
		DomsanitizerPipe
	]
})

// @NgModule({
//   declarations: [],
//   imports: [
//     CommonModule
//   ]
// })
export class PipesModule { }
